"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import imageUrlBuilder from "@sanity/image-url";
import { cn } from "@repo/ui/utils";
import { Link } from "@/i18n/navigation";
import type { AgentHit } from "./agent-chat.types";
const builder = imageUrlBuilder({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ?? "",
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET ?? "production"
});
function imageUrlFromRef(ref: string, isLogo = false): string {
  const img = builder.image(ref).auto("format");
  return isLogo ? img.width(400).fit("max").url() : img.width(400).height(240).fit("crop").url();
}
export function AgentResultItem(t0) {
  const $ = _c(21);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.imageRef || $[1] !== item.imageUrl || $[2] !== item.isLogo) {
    t1 = item.imageUrl ?? (item.imageRef ? imageUrlFromRef(item.imageRef, item.isLogo) : null);
    $[0] = item.imageRef;
    $[1] = item.imageUrl;
    $[2] = item.isLogo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const imageUrl = t1;
  const href = item.slug ? item.slug.startsWith("/") ? item.slug : `/${item.slug}` : "#";
  let t2;
  if ($[4] !== imageUrl || $[5] !== item.isLogo) {
    t2 = imageUrl && <div className={cn("relative aspect-[16/10] w-full overflow-hidden", item.isLogo && "bg-surface-base-secondary")}><Image src={imageUrl} alt="" fill={true} sizes="240px" className={cn(item.isLogo ? "object-contain" : "object-cover transition-transform duration-300 ease-out group-hover:scale-105")} /></div>;
    $[4] = imageUrl;
    $[5] = item.isLogo;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== item.typeLabel) {
    t3 = item.typeLabel && <span className="typography-component-xs-medium uppercase text-text-secondary">{item.typeLabel}</span>;
    $[7] = item.typeLabel;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== item.title) {
    t4 = item.title && <h3 className="line-clamp-2 typography-body-sm-medium text-text-primary group-hover:underline">{item.title}</h3>;
    $[9] = item.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== item.description) {
    t5 = item.description && <p className="line-clamp-2 typography-body-xs-regular text-text-secondary">{item.description}</p>;
    $[11] = item.description;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="flex flex-1 flex-col gap-1 p-3">{t3}{t4}{t5}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== href || $[18] !== t2 || $[19] !== t6) {
    t7 = <Link href={href} className="group flex h-full w-full flex-col overflow-hidden rounded-sm border border-border-subtle bg-surface-base-primary transition-colors hover:border-border-active">{t2}{t6}</Link>;
    $[17] = href;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}